import { useRsrc } from '@/common/rsrc/RsrcContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  timelineOppositeContentClasses,
  TimelineSeparator,
} from '@mui/lab';
import { Button, Divider, Icon, List, ListItem, ListItemIcon, ListItemText, Typography, useTheme } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
import { far, fas } from '@awesome.me/kit-b4fd369ea4/icons';
import React, { useEffect, useState } from 'react';
import { KrDialog } from '../dialog/Dialog';

export const ApprRouteProgressDialog = ({ data, closeDialog }) => {
  const [stepSpecs, setStepSpecs] = useState();
  const theme = useTheme();
  const rsrc = useRsrc();

  useEffect(() => {
    const reqParam = { apprJobId: data.apprJobId };
    rsrc.data('admin', 'APPR_ROUTE_PROGRESS_DATA_PLUGIN', reqParam).then((stepSpecs) => {
      setStepSpecs(stepSpecs);
    });
  }, [data.apprJobId]);

  const getColor = (progress) => {
    switch (progress) {
      case 'APPROVED':
        return '#4caf50'; // green
      case 'STARTED':
        return '#4caf50'; // green
      case 'APPROVAL_PENDING':
        return '#cec042'; // yellow
      default:
        return '#9e9e9e'; // grey for NOT_STARTED
    }
  };

  // Icons for the timeline steps
  const getIcon = (progress) => {
    switch (progress) {
      case 'APPROVED':
        return fas.faCheck;
      case 'STARTED':
        return fas.faArrowRight; // using play icon for started
      case 'APPROVAL_PENDING':
        return fas.faStamp; // using stamp for pending
      default:
        return far.faClock;
    }
  };
  const ApprRouteProgressNode = ({ label, progress, rightContent, showConnector }) => {
    return (
      <TimelineItem sx={{ minHeight: 120 }}>
        <TimelineOppositeContent sx={{ pt: '38px' }}>{label}</TimelineOppositeContent>
        <TimelineSeparator sx={{ pt: '14px' }}>
          <TimelineDot
            variant="filled"
            sx={{
              backgroundColor: getColor(progress),
            }}
          >
            <Icon fontSize="large" sx={{ justifyItems: 'center', display: 'block' }}>
              <FontAwesomeIcon
                fixedWidth
                style={{
                  height: '100%',
                  width: '75%',
                  display: 'block',
                }}
                icon={getIcon(progress)}
              />
            </Icon>
          </TimelineDot>
          {showConnector && <TimelineConnector sx={{ height: '50px', position: 'relative', top: '8px' }} />}
        </TimelineSeparator>
        <TimelineContent sx={{ pr: 0, pt: '10px' }}>{rightContent} </TimelineContent>
      </TimelineItem>
    );
  };
  return (
    stepSpecs && (
      <KrDialog
        closeDialog={closeDialog}
        maxWidth="md"
        fullWidth
        title="Approval Route Progress"
        buttons={
          <Button onClick={closeDialog} variant="contained" color="primary">
            Close
          </Button>
        }
      >
        <Timeline
          sx={{
            [`& .${timelineOppositeContentClasses.root}`]: {
              flex: 0.3,
            },
            m: 0,
          }}
        >
          {stepSpecs.map((step, index) => (
            <ApprRouteProgressNode
              key={index}
              label={step.label}
              progress={step.progress}
              showConnector={index !== stepSpecs.length - 1}
              rightContent={
                step?.userApprSpecs.length > 0 && (
                  <List
                    sx={{
                      maxWidth: 360,
                      borderRadius: '20px',
                      backgroundColor: theme.palette.surface.low,
                      // border: `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    {step.userApprSpecs.map((user, uIndex) => {
                      const isLast = uIndex === step.userApprSpecs.length - 1;
                      return (
                        <React.Fragment key={uIndex}>
                          <ListItem>
                            <ListItemIcon>
                              <FontAwesomeIcon
                                size="2x"
                                icon={getIcon(user.progress)}
                                style={{ color: getColor(user.progress) }}
                              />
                            </ListItemIcon>

                            <ListItemText
                              primary={`${user.firstname} ${user.lastname}`}
                              secondary={
                                <>
                                  <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{ color: 'text.primary', display: 'inline' }}
                                  >
                                    {user.username}
                                  </Typography>
                                  {user.apprGroup && ` - ${user.apprGroup}`}
                                </>
                              }
                            />
                          </ListItem>
                          {!isLast && <Divider component="li" sx={{ borderColor: 'surface.high' }} />}
                        </React.Fragment>
                      );
                    })}
                  </List>
                )
              }
            />
          ))}
        </Timeline>
      </KrDialog>
    )
  );
};
